import {
  Identifiable,
  Planzone,
  ProjectReportField,
  ProjectReportTemplate,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function normalizeTemplate(
  template: ProjectReportTemplate | ProjectReportField[],
): ProjectReportTemplate {
  return Array.isArray(template)
    ? (template as ProjectReportField[]).reduce<ProjectReportTemplate>(
        (acc, field, index) =>
          field.type === "indicator"
            ? {
                ...acc,
                indicators: [
                  ...acc.indicators,
                  { ...field, order: "order" in field ? field.order : index },
                ],
              }
            : {
                ...acc,
                textFields: [
                  ...acc.textFields,
                  { ...field, order: "order" in field ? field.order : index },
                ],
              },
        { name: "", indicators: [], textFields: [] },
      )
    : template;
}

function extractTemplates({
  data,
}: Identifiable<Planzone>): Identifiable<ProjectReportTemplate>[] {
  if (data.projectReportTemplates) {
    try {
      const templates = JSON.parse(data.projectReportTemplates);
      if (Array.isArray(templates) && templates.length > 0) {
        return templates.map((t: Identifiable<ProjectReportTemplate>) => ({
          ...t,
          ...normalizeTemplate(t),
        }));
      }
    } catch {
      // fall through to legacy
    }
  }

  const legacy = JSON.parse(
    data.projectReportTemplate || '{"name":"","indicators":[],"textFields":[]}',
  );
  const normalized = normalizeTemplate(legacy);

  return [
    {
      uuid: "legacy-default",
      name: normalized.name || "Default",
      indicators: normalized.indicators,
      textFields: normalized.textFields,
    },
  ];
}

function getProjectReportTemplate(httpClient: HttpClient) {
  return (planzone: Identifiable<Planzone>) =>
    httpClient
      .sendHttpRequest<Identifiable<Planzone>>({
        endpoint: `/planzones/${planzone.uuid}`,
        method: HttpMethods.GET,
      })
      .then(extractTemplates);
}

export { getProjectReportTemplate };
